export const returnLabel = (obj: any, key: string, value: any) => {
  const arr = obj[key] || [];
  return arr.find((item: any) => item.value === value)?.label || null;
};
